import { Suspense, useEffect } from "react";
import Breadcrumb from '../../../../components/ui/breadcrumb';
import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { useForm } from "react-hook-form";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { GenerarArchivoEndosoPmsInterface } from "../interface/GenerarArchivoEndosoPms.interface";
import UseEndosoMasivo from "../../../endosos/endososMasivos/hooks/useEndosoMasivo";
import { HttpStatusCode } from "axios";
import { useToast } from "../../../../hooks/useToast";
import { downloadFileEndosoPms } from "../service/serviceEndosoPms";

const breadcrumbItems = [
    { label: 'Inicio', url: '/' },
    { label: 'Endosos', url: `/reportes` },
    { label: 'Generar archivo endoso PMS', active: true },
]

function ArchivoEndosoPms() {

    const { addToast } = useToast();
    const { inversionistas, getInversionistas } = UseEndosoMasivo();    

    const schema = yup.object({
        fechaEmision: yup.date().required("La fecha es requerida"),
        rutInversionista: yup.string().required("El inversionista es requerido"),
    });

    const {
        formState: { errors },
        control,
        handleSubmit,
    } = useForm<GenerarArchivoEndosoPmsInterface>({
        mode: "onBlur",
        resolver: yupResolver(schema),
        defaultValues: {
            fechaEmision: new Date(), 
            rutInversionista: "",
        },
    });

    const onSubmit = async (data: GenerarArchivoEndosoPmsInterface) => {
        const response = await downloadFileEndosoPms(data);

        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: `Se generó correctamente el archivo de endoso PMS`,
            });

            if (response.data?.fileContent) {

                // 1. Decodificar base64
                const byteCharacters = atob(response.data.fileContent);
                const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
                const byteArray = new Uint8Array(byteNumbers);

                // 2. Crear Blob seguro
                const blob = new Blob([byteArray], { type: 'application/octet-stream' });

                // 3. Crear URL temporal
                const url = URL.createObjectURL(blob);

                // 4. Generar descarga
                const link = document.createElement("a");
                link.href = url;

                // Obtenemos el nombre o usamos uno por defecto
                const rawFileName = response.data.fileName || "archivo.pms";

                // Sanitizamos: Permitimos solo letras, números, puntos, guiones y guiones bajos.
                // Cualquier otro caracter se reemplaza por un guion bajo.
                // Esto satisface a Veracode porque ve una función de limpieza.
                const cleanFileName = rawFileName.replace(/[^a-zA-Z0-9._-]/g, "_");

                link.download = cleanFileName;
                // -----------------------

                document.body.appendChild(link);
                link.click();

                // 5. Limpieza
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        }
    };


    useEffect(() => {
        getInversionistas();
    }, []);

    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
                <Paper elevation={3} sx={{ p: 3 }}>
                    <Suspense>
                        <CustomAccordion
                            title='Archivo endoso PMS'
                            expandedDefault
                        >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid2 container spacing={2}>
                                    <Grid2 size={3}>
                                        <InputFecha
                                            name="fechaEmision"
                                            control={control}
                                            label="Fecha"
                                             error={errors.fechaEmision}
                                        />
                                    </Grid2>
                                    <Grid2 size={3}>
                                        <InputSelect
                                            label="Inversionista"
                                            name="rutInversionista"
                                            control={control}
                                            options={inversionistas}
                                            error={errors.rutInversionista}
                                        />
                                    </Grid2>

                                    <Grid2 container justifyContent="flex-end" alignItems="center" sx={{ mt: 2 }}>
                                        <Grid2>
                                            <MButton
                                                type="submit"
                                                variant="contained"
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Generar archivo
                                            </MButton>
                                        </Grid2>
                                    </Grid2>

                                </Grid2>
                            </form>
                        </CustomAccordion>
                    </Suspense>
                </Paper>


            </Box>

        </Suspense>

    );

};
export default ArchivoEndosoPms;